import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { AppSidebar } from './sidebar'
import { WhatsAppFloatingButton, ImpersonationBanner, PlanLimitBlockDialog } from 'components'

const RightBar = styled.div`

`

export function Layout({ children }) {
    const { pathname } = useLocation()
    const flushTop = pathname.startsWith('/app/settings')

    return (
        <>
            <AppSidebar>
                <RightBar>
                    <ImpersonationBanner />
                    <div className={flushTop ? undefined : 'mt-3'}>{children}</div>
                </RightBar>
            </AppSidebar>
            <WhatsAppFloatingButton />
            <PlanLimitBlockDialog />
        </>
    )
}
